import { lazyLoad } from 'utils/loadable';

export const Orders = lazyLoad(() => import('./index'));
